import { useCallback, useMemo } from 'react';

export const useImageAttachments = ({ attachments }: { attachments: Array<{ contentType?: string; id: string }> }) => {
  const imageAttachments = useMemo(
    () => attachments.filter((attachment) => attachment.contentType?.startsWith('image/')),
    [attachments],
  );

  const isImageAttachment = useCallback(
    ({ attachmentId }: { attachmentId: string }) =>
      imageAttachments.some((imageAttachment) => imageAttachment.id === attachmentId),
    [imageAttachments],
  );

  return useMemo(() => ({ imageAttachments, isImageAttachment }), [imageAttachments, isImageAttachment]);
};
